var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1547_534",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1547_534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 16.0007V13.334H14.6666V16.0007H1.33325ZM2.66659 12.0007V9.16732L10.1333 1.71732C10.2555 1.5951 10.3971 1.50065 10.5583 1.43398C10.7194 1.36732 10.8888 1.33398 11.0666 1.33398C11.2444 1.33398 11.4166 1.36732 11.5833 1.43398C11.7499 1.50065 11.8999 1.60065 12.0333 1.73398L12.9499 2.66732C13.0833 2.78954 13.1805 2.93398 13.2416 3.10065C13.3027 3.26732 13.3333 3.43954 13.3333 3.61732C13.3333 3.78398 13.3027 3.94787 13.2416 4.10898C13.1805 4.2701 13.0833 4.41732 12.9499 4.55065L5.49992 12.0007H2.66659ZM11.0666 4.53398L11.9999 3.60065L11.0666 2.66732L10.1333 3.60065L11.0666 4.53398Z",
    fill: "#0A7989"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.b2ccc53310f492f55092fe50406d0812.svg";
export { ForwardRef as ReactComponent };